const SERVER_URL = 'https://adasoft.ar/api'
//const SERVER_URL = 'http://localhost:4000/api'

export const APIs = {

    PRODUCTS: SERVER_URL + '/products',
    USERS: SERVER_URL + '/users',
    PURCHASE: SERVER_URL + '/purchase/create',
    MERCADOPAGO: SERVER_URL + '/mercadopago',
    CATEGORY: SERVER_URL + '/category',


};